import React, { Component } from 'react'
import { browserHistory } from 'react-router'
import { connect } from 'react-redux'
import { bindActionCreators } from 'redux'
import cookie from 'react-cookie'
import CSSModules from 'react-css-modules'
import Menu from '../todayTask/Menu'
import CalendarList from '../todayTask/CalendarList'
import Header from '../componentKit/Header'
import TaskIntro from '../todayTask/TaskIntro'
import HeaderTask from '../componentKit2/HeaderTask'
import MobileLeftMenu from '../componentKit2/MobileLeftMenu'
import { PRIVATE_CHAT_ID } from '../../actions'
import styles from './mainComponent.css'

const scrollUpStyle = {
  zIndex: 2000,
  position: 'fixed',
  fontSize: 16,
  bottom: 60,
  left: 30,
  cursor: 'pointer',
  transitionDuration: '0.2s',
  transitionTimingFunction: 'linear',
  transitionDelay: '0s'
}

class MainComponent extends Component {


  render() {
    const { food, taskDay, sign } = this.props
    const { calendar, id, user: { role } } = taskDay
    const introJSON = food && food.content ? JSON.parse(food.content) : null

    return (
    <div>
      <TaskIntro sign={sign} json={introJSON} />
    </div>
    )
  }
}

const mapStateToProps = state => {
  const { showMobileLeftMenu, foodTab, sign } = state

  return {
    showMobileLeftMenu,
    sign,
    foodTab
  }
}

const mapDispatchToProps = dispatch => ({
  showLeftMenu: bindActionCreators(
    () => dispatch({ type: 'SHOW_LEFT_MENU', show: true }),
    dispatch
  ),
  hideLeftMenu: bindActionCreators(
    () => dispatch({ type: 'SHOW_LEFT_MENU', show: false }),
    dispatch
  ),
  chooseTab: bindActionCreators(
    tab => dispatch({ type: 'CHANGE_FOOD_TAB', tab }),
    dispatch
  ),
})

MainComponent = connect(
  mapStateToProps,
  mapDispatchToProps
)(MainComponent)

export default CSSModules(MainComponent, styles)



// WEBPACK FOOTER //
// /var/www/build-health-2/src/components/food/MainComponent.js